__turbopack_context__.v({
  "blocksBackgroundColor": "PageIndexPage-module-scss-module__JaKBAG__blocksBackgroundColor",
  "blocksFontColor": "PageIndexPage-module-scss-module__JaKBAG__blocksFontColor",
  "categoryBadgeIcon": "PageIndexPage-module-scss-module__JaKBAG__categoryBadgeIcon",
  "container": "PageIndexPage-module-scss-module__JaKBAG__container",
  "letterButton": "PageIndexPage-module-scss-module__JaKBAG__letterButton",
  "letterFilter": "PageIndexPage-module-scss-module__JaKBAG__letterFilter",
  "letterHeader": "PageIndexPage-module-scss-module__JaKBAG__letterHeader",
  "letterList": "PageIndexPage-module-scss-module__JaKBAG__letterList",
  "list": "PageIndexPage-module-scss-module__JaKBAG__list",
  "loadMoreTrigger": "PageIndexPage-module-scss-module__JaKBAG__loadMoreTrigger",
  "mainContent": "PageIndexPage-module-scss-module__JaKBAG__mainContent",
  "secondaryNavBackgroundColor": "PageIndexPage-module-scss-module__JaKBAG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "PageIndexPage-module-scss-module__JaKBAG__themeBackgroundColor",
  "themeFontColor": "PageIndexPage-module-scss-module__JaKBAG__themeFontColor",
  "themeFontFamily": "PageIndexPage-module-scss-module__JaKBAG__themeFontFamily",
});
